<template>
  <el-form
    ref="ruleForm"
    :labelPosition="labelPosition"
    :model="form.ruleForm"
    :rules="form.rules"
    class="demo-ruleForm"
    label-width="100px"
  >
    <el-form-item label="公司名称" prop="corporateName">
      <el-input
        v-model="form.ruleForm.corporateName"
        :disabled="!isEdit"
        maxlength="16"
        minlength="3"
        placeholder="请输入"
      />
    </el-form-item>
    <el-form-item label="印章名称" prop="sealName">
      <el-input
        v-model="form.ruleForm.sealName"
        :disabled="!isEdit"
        maxlength="16"
        minlength="3"
        placeholder="请输入印章名称"
      />
    </el-form-item>
    <el-form-item label="印章类型" prop="sealType">
      <el-select
        v-model="form.ruleForm.sealType"
        :disabled="!isEdit"
        clearable
        placeholder="请选择印章类型"
        style="width: 100%;"
      >
        <el-option
          v-for="item in enums.sealType"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="印章形状" prop="sealShape">
      <el-radio-group v-model="form.ruleForm.sealShape" :disabled="!isEdit" @change="drawImage">
        <el-radio
          v-for="ss in enums.sealShape"
          :key="ss.id"
          :label="ss.value"
        >
          {{ ss.label }}
        </el-radio>
      </el-radio-group>
    </el-form-item>
    <template v-if="form.ruleForm.radio === 'square'">
      <el-form-item label="一列多少字" prop="fontNum">
        <el-input-number
          v-model="form.ruleForm.fontNum"
          :max="7"
          :min="1"
          @change="drawImage"
        />
      </el-form-item>
      <el-form-item label="横向间距" prop="transverse">
        <el-slider v-model="form.ruleForm.transverse" @change="drawImage"></el-slider>
      </el-form-item>
      <el-form-item label="竖向间距" prop="fontNum">
        <el-slider v-model="form.ruleForm.vertical" @change="drawImage"></el-slider>
      </el-form-item>
    </template>
    <el-form-item>
      <el-button plain type="primary" @click="drawImage">绘制电子章</el-button>
    </el-form-item>
    <el-form-item>
      <canvas v-show="canvas.show" id="canvas" ref="canvas" height="250" width="250"></canvas>
    </el-form-item>
  </el-form>
</template>

<script>
import {mapGetters} from "vuex"

let that
export default {
  props: ['labelPosition', 'corporateName', 'sealName', 'sealType', 'sealShape', 'isEdit'],
  computed: {
    ...mapGetters([
      'enums', // 枚举
    ]),
  },
  data() {
    return {
      dialog: {
        show: false
      },
      form: {
        ruleForm: {
          corporateName: '', //公司名
          sealName: '', //印章名
          sealShape: 'circular', //默认圆形
          sealType: '公章', // 印章类型，如公章
          fontNum: 4, //一列多少字
          transverse: 30, //横向间距
          vertical: 20 //竖向间距
        },
        rules: {
          corporateName: [{
            required: true,
            message: '请输入公司名称',
            trigger: 'blur'
          },
            // {
            // 	validator: this.$lizhao.test.checkEmail,
            // 	trigger: 'change'
            // }
          ],
          sealName: [{
            required: true,
            message: '请输入印章名',
            trigger: 'blur'
          }],
          sealType: [{
            required: true,
            message: '请选择印章类型',
            trigger: 'blur'
          }],
          sealShape: [{
            required: true,
            message: '必填项',
            trigger: 'blur'
          }],
          fontNum: [{
            required: true,
            message: '必填项',
            trigger: 'blur'
          }],
          transverse: [{
            required: true,
            message: '必填项',
            trigger: 'blur'
          }],
          vertical: [{
            required: true,
            message: '必填项',
            trigger: 'blur'
          }],
        }
      },
      canvas: {
        show: false,
        context: null, //画布
      },
    }
  },
  mounted() {
    that = this
    this.form.ruleForm = {
      ...this.form.ruleForm,
      corporateName: this.corporateName,
      sealName: this.sealName,
      sealShape: this.sealShape,
      sealType: this.sealType,
    }
    console.log('ruleForm', this.form.ruleForm)
  },
  methods: {
    //创建canvas
    createCanvas() {
      this.canvas.show = false
      this.canvas.show = true
      this.canvas.context = this.$refs.canvas.getContext('2d')
      // 清除画布法一
      this.canvas.context.fillStyle = 'rgba(255, 255, 255, 0)';
      this.canvas.context.beginPath();
      this.canvas.context.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
      this.canvas.context.closePath();

    },
    //点击生成
    drawImage() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.form.ruleForm.sealName.length > 10) {
            this.$message.warning('最大输入长度10')
            return
          }
          this.createCanvas()
          this.$nextTick(() => {
            if (this.form.ruleForm.sealShape === 'circular') {
              //绘制圆形电子章
              this.drawCircularSeal()
            } else if (this.form.ruleForm.sealShape === 'ellipse') {
              //绘制椭圆形电子章
              this.drawEllipseSeal()
            } else if (this.form.ruleForm.sealShape === 'square') {
              //绘制方形电子章
              this.drawSquareSeal()
            }
            // 绘制完成后返回图片base64
            this.$emit('updateCanvasUrl', this.$refs.canvas.toDataURL())
            this.$emit('submitForm', this.form.ruleForm)
          })
        }
      });


    },
    //绘制方形电子章
    drawSquareSeal() {
      let context = this.canvas.context;
      var width = this.$refs.canvas.width / 2;
      var height = this.$refs.canvas.height / 2;
      context.lineWidth = 5;
      context.strokeStyle = "#f00";
      context.rect(width - (width + 60) / 2, height - (height + 60) / 2, width + 60, height + 60);
      context.stroke();
      context.save();
      //绘制方形文字
      // this.drawSquareText(context,width,height,this.form.ruleForm.corporateName)
      this.writeTextOnCanvas(context, width, height, this.form.ruleForm.corporateName)
    },
    //绘制方形文字
    drawSquareText(context, width, height, text) {
      context.font = 'normal bold 18px 宋体';
      context.textBaseline = 'alphabetic'; //设置文本的垂直对齐方式
      context.textAlign = 'start'; //设置文本的水平对对齐方式
      context.fillStyle = '#f00';
      context.lineWidth = 2;
      let count = text.length; // 字数
      let chars = text.split("");
      //获取可以画多少行字
      let row = Math.ceil(text.length / this.form.ruleForm.fontNum)
      let str = ''
      let strArr = [] //每多少个字放一个数组里
      for (var i = 0; i < count; i++) {
        str += chars[i]
        if ((i + 1) % this.form.ruleForm.fontNum === 0) {
          strArr.push(str)
          str = ''
        } else if (i + 1 === count) {
          strArr.push(str)
        }
      }
      console.log(strArr);
      //开始画每一行文字
      // 起始左上角为坐标x,y如下
      let X = width - (width + 60) / 2
      let Y = height - (height + 60) / 2
      for (var i = 0; i < strArr.length; i++) {
        let spacing = 30 * (i + 1)
        context.fillText(strArr[i], X, Y + spacing, width + 60); // width+60为盒子宽度
      }


      context.restore();

    },
    // 竖排处理
    writeTextOnCanvas(context, width, height, text) {
      context.font = 'normal bold 26px 宋体';
      context.textBaseline = 'alphabetic'; //设置文本的垂直对齐方式
      context.textAlign = 'start'; //设置文本的水平对对齐方式
      context.fillStyle = "#f00";
      // 文字开始的坐标
      let x = width - (width + 60) / 2 + width + 60,
        y = height - (height + 60) / 2 + 5;
      //获取可以画多少行字
      // let row = Math.ceil(text.length/this.form.ruleForm.fontNum);
      //当前行
      let index = 1
      let count = text.length; // 字数
      let chars = text.split("");
      for (let i = 0; i < text.length; i++) {
        const str = text.slice(i, i + 1).toString();
        context.save();
        context.fillStyle = "#f00";
        context.textBaseline = 'top';
        context.fillText(str, x - this.form.ruleForm.transverse * index, y);
        context.restore();
        y += context.measureText(str).width + this.form.ruleForm.vertical; // 计算文字宽度
        if ((i + 1) % this.form.ruleForm.fontNum === 0) {
          index++
          //y还原
          y = height - (height + 60) / 2 + 5
        }
      }
    },

    //绘制椭圆形电子章
    drawEllipseSeal() {
      let context = this.canvas.context;
      var width = this.$refs.canvas.width / 2;
      var height = this.$refs.canvas.height / 2;
      //绘制椭圆形边框
      if (context.ellipse) {
        context.lineWidth = 5;
        context.strokeStyle = "#f00";
        context.beginPath(); //起始一条路径，或重置当前路径
        // (起点x.起点y,半径x,半径y,旋转的角度，起始角，结果角，顺时针还是逆时针)
        context.ellipse(width, height, 120, 85, 0, 0, Math.PI * 2);
        context.stroke();
        //绘制五角星
        this.create5star(context, width, height, 25, "#f00", 0);
        // 绘制公司名称
        this.createEllipseCorporateName(context, width, height, this.form.ruleForm.corporateName)
        //绘制印章名称
        this.createEllipseSealName(context, width, height, this.form.ruleForm.sealName)
      }
    },
    //绘制椭圆印章名称
    createEllipseSealName(context, width, height, text) {
      context.font = 'normal bold 14px 宋体';
      context.textBaseline = 'middle'; //设置文本的垂直对齐方式
      context.textAlign = 'center'; //设置文本的水平对对齐方式
      context.lineWidth = 20;
      context.fillStyle = '#f00';
      context.save();
      context.translate(width, height + 50); // 平移到此位置,
      context.scale(1.2, 1.2); //伸缩要先把远点平移到要写字的位置，然后在绘制文字
      context.fillText(text, 0, 0, 100); //原点已经移动
      context.restore();
    },
    //绘制椭圆形文字（公司名称）
    createEllipseCorporateName(context, width, height, text, type) {
      context.save();
      context.font = 'normal  16px 宋体';
      context.textBaseline = 'alphabetic'; //默认值
      context.textAlign = 'center'; //设置文本的水平对对齐方式
      context.fillStyle = '#f00';
      context.translate(width, height); // 平移到此位置,
      let count = text.length; // 字数
      let chars = text.split("");
      var circle = {
        x: width,
        y: height,
        radius: width
      };
      //控制字符起始位置度数
      var startAngle = 86 + 8 * count / 2;
      //圆的半径
      var radius = circle.radius - 10
      context.scale(1, 0.93);
      context.lineWidth = 1;
      for (var i = 0; i < count; i++) {
        context.save()
        context.beginPath()
        //绘制点
        context.translate(circle.x + Math.cos((Math.PI / 180) * startAngle) * radius, circle.y - Math.sin((Math
          .PI / 180) * startAngle) * radius)
        context.translate(-126, -80)
        context.rotate((Math.PI / 2) - (Math.PI / 180) * startAngle) //Math.PI/2为旋转90度  Math.PI/180*X为旋转多少度
        context.fillText(chars[i], 0, 0)
        context.strokeText(chars[i], 0, 0)
        startAngle -= 8 //控制间隙
        context.restore()
      }
      // 设置画布为最初的位置为原点，旋转回平衡的原位置，用于清除画布
      context.scale(1, 1 / 0.93);
      context.translate(-width, -height);
    },
    //绘制圆形电子章
    drawCircularSeal() {
      let context = this.canvas.context;
      // 绘制印章边框
      var width = this.$refs.canvas.width / 2;
      var height = this.$refs.canvas.height / 2;
      //绘制圆心边框
      this.circularBorder(context, width, height)
      //绘制五角星
      this.create5star(context, width, height, 25, "#f00", 0);
      //绘制印章名称
      this.createSealName(context, width, height, this.form.ruleForm.sealName)
      // 绘制公司名称
      this.createCorporateName(context, width, height, this.form.ruleForm.corporateName)
    },
    //绘制圆心边框
    circularBorder(context, width, height) {
      context.lineWidth = 5;
      context.strokeStyle = "#f00";
      context.beginPath(); //起始一条路径，或重置当前路径
      context.arc(width, height, width - 20, 0, Math.PI * 2); //宽、高、半径
      context.stroke(); //绘制已定义的路径
    },
    //绘制公司名称
    createCorporateName(context, width, height, text) {
      context.font = 'normal bold 16px 黑体';
      context.translate(width, height); // 平移到此位置,
      let count = text.length; // 字数
      let angle = Math.PI / 12; // 字间角度 25度 （相当于字的间隔）
      let chars = text.split("");
      for (var i = 0; i < count; i++) {
        //绕canvas的画布圆心旋转
        if (i === 0) {
          //以圆心正上方为中心点两边绘制文字
          context.rotate(-Math.PI / 2 - angle / 2 * (count - 1));
        } else {
          context.rotate(angle); //后面的字依次旋转25度间隔
        }
        context.save();
        context.translate(90, 0); // 平移到此位置,此时字和x轴垂直，公司名称和最外圈的距离
        context.rotate(Math.PI / 2); // 旋转90度,让字平行于x轴
        // context.scale(1,2);//伸缩画布，实现文字的拉长
        context.fillText(chars[i], 0, 0); // 此点为字的中心点
        context.restore();
      }
      // 设置画布为最初的位置为原点，旋转回平衡的原位置，用于清除画布
      context.rotate(-Math.PI / 2 - angle / 2 * (count - 1) + Math.PI);
      context.translate(-width, -height);

    },
    //绘制印章名称
    createSealName(context, width, height, text) {
      context.font = 'normal bold 14px 宋体';
      context.textBaseline = 'middle'; //设置文本的垂直对齐方式
      context.textAlign = 'center'; //设置文本的水平对对齐方式
      context.lineWidth = 20;
      context.fillStyle = '#f00';
      context.save();
      context.translate(width, height + 50); // 时平移到此位置,
      context.scale(1.1, 1.1); //伸缩要先把远点平移到要写字的位置，然后在绘制文字
      context.fillText(text, 0, 0, 100); //原点已经移动
      context.restore();
    },
    //绘制五角星
    create5star(context, sx, sy, radius, color, rotato) {
      context.save(); //保存当前环境的状态
      context.fillStyle = color;
      context.translate(sx, sy); //移动坐标原点，重新映射画布上的 (0,0) 位置
      context.rotate(Math.PI + rotato); //旋转
      context.beginPath(); //创建路径
      var dig = Math.PI / 5 * 4;
      for (var i = 0; i < 5; i++) { //画五角星的五条边
        var x = Math.sin(i * dig);
        var y = Math.cos(i * dig);
        context.lineTo(x * radius, y * radius);
      }
      context.closePath(); //创建从当前点回到起始点的路径
      context.stroke(); //绘制已定义的路径
      context.fill();
      context.restore(); //返回之前保存过的路径状态和属性
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/drawElectronicSeal/drawSeal.vue